import ReactMarkdown from "react-markdown";
import { useState } from "react";
import { RemoveScroll } from "react-remove-scroll";
import { NavLink } from "react-router-dom";

export const TermsModal = ({ open, setOpen, terms }) => {
  const [everythingWasRead, setEverythingWasRead] = useState(false);

  const handleScroll = (e) => {
    if (e.target.scrollTop >= 50) {
      setEverythingWasRead(true);
    }
  };

  if (!open) {
    return null;
  }

  return (
    <>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="fixed left-0 right-0 top-0 z-[500] flex h-screen max-h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden bg-dark-100/[.9] md:inset-0"
      >
        <div className="relative max-h-full w-full max-w-7xl p-4">
          <div className="relative rounded-lg bg-white shadow dark:bg-gray-700">
            <div className="flex items-center justify-between rounded-t border-b p-4 dark:border-gray-600 md:p-5">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Termeni și Condiții
              </h3>
            </div>
            <RemoveScroll
              onScroll={handleScroll}
              className="singlePage max-h-[60vh] space-y-4 overflow-y-auto p-4 md:p-5"
            >
              <ReactMarkdown>{terms}</ReactMarkdown>
            </RemoveScroll>

            <div className="flex items-center rounded-b border-t border-gray-200 p-4 dark:border-gray-600 md:p-5">
              <button
                onClick={() => {
                  setOpen(false);
                }}
                type="button"
                disabled={!everythingWasRead}
                className="rounded-lg bg-primary-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300 disabled:bg-gray-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 dark:disabled:bg-gray-600"
              >
                Continuă
              </button>
              <NavLink
                to="/"
                className="ms-3 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-700"
              >
                Mergi la pagina principală
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
